import React, { useState } from 'react';

export const EMOJI = ['👍', '❤️', '😂', '🎉', '🙏', '🔥'];

/* Emoji under a comment or group message: tap one to add it, another to swap,
   the same again to take it off. Hover a chip to see who. `onReact(emoji)`
   does the request and returns the updated item. */
export default function EmojiReactions({ reactions = [], myId, onReact, label = 'this' }) {
  const [picking, setPicking] = useState(false);
  const mine = reactions.find((r) => r.people.some((p) => p.id === myId))?.emoji;
  const react = (emoji) => { setPicking(false); onReact(emoji); };
  return (
    <div className="fc-c-reacts">
      {reactions.map((r) => (
        <button key={r.emoji} type="button" className={`fc-c-chip${r.emoji === mine ? ' on' : ''}`}
          title={r.people.map((p) => p.name).join(', ')} aria-pressed={r.emoji === mine}
          aria-label={`${r.emoji} ${r.count}: ${r.people.map((p) => p.name).join(', ')}`} onClick={() => react(r.emoji)}>
          <span aria-hidden="true">{r.emoji}</span> {r.count}
        </button>
      ))}
      <span className="fc-c-pick">
        <button type="button" className="fc-c-add" aria-label={`React to ${label}`} aria-expanded={picking}
          onClick={() => setPicking(!picking)}>🙂 +</button>
        {picking && (
          <span className="fc-c-palette" role="menu" onMouseLeave={() => setPicking(false)}>
            {EMOJI.map((e) => (
              <button key={e} type="button" role="menuitem" className={e === mine ? 'on' : ''} onClick={() => react(e)}>{e}</button>
            ))}
          </span>
        )}
      </span>
    </div>
  );
}
